import script from "./LoginFree.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginFree.vue?vue&type=script&setup=true&lang=js"

import "./LoginFree.vue?vue&type=style&index=0&id=1c16acf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c16acf8"]])

export default __exports__